export const SET_VEHICLE_SORTING = 'SET_VEHICLE_SORTING';

export const setVehiclesSorting = (newSorting) => ({
  type: SET_VEHICLE_SORTING,
  payload: newSorting,
});
